import { IntegrationApiFeaturesCongestionContractsResponsesGetCongestionsResponse as CongestionsResponse } from '@alliander-fe/api';
import { isResolvedCongestion } from './isResolvedCongestion';

export const hasCongestions = (data: undefined | CongestionsResponse) => {
  const consumeCongestion = data?.directions?.consume
    ? isResolvedCongestion(data.directions.consume?.highestLevel)
    : false;
  const supplyCongestion = data?.directions?.supply
    ? isResolvedCongestion(data.directions.supply?.highestLevel)
    : false;

  return {
    consume: consumeCongestion,
    supply: supplyCongestion,
  };
};

